import React from 'react';
import { ICompanyResponse } from '../../../Interfaces/responseTypes';
import { BUSINESS_TYPE_ICONS } from '../../../Costants/costants';
import { Popper } from '@mui/material';
import CustomDialog from '../../Dialog/customDialog';
import DeleteCompanyDialog from '../../Dialog/DialogContents/Business/DeleteCompany/deleteCompanyDialog';
import useBusinessDashboardCard from './businessDashboardCard-hooks';
import { MoreDots, Trash } from '../../../Assets/Icons';
import styles from './busineasDashboardCard.module.scss';

interface IProps {
    data: ICompanyResponse
};

const BusinesDashboardCard: React.FC<IProps> = ({ data }) => {
    const {
        t,
        id,
        open,
        anchor,
        baseURL,
        openPopper,
        onOpen,
        onClose,
        handleCardClick,
        handleMoreIconClick,
        handleMouseLeaveContainer,
        handlePopperMouseEnter,
        handlePopperMouseLeave,
    } = useBusinessDashboardCard();

    return (
        <div
            className={styles.container}
            onClick={() => handleCardClick(data.id)}
            onMouseLeave={handleMouseLeaveContainer}
        >
            <div className={styles.titleRow}>
                <img src={`${baseURL}${data.logo}`} alt={`${data.logo}.png`} className={styles.logo} />
                <p className={styles.title}>{data.name}</p>
            </div>
            <div className={styles.infoRow}>
                <div className={styles.infoBox}>
                    <div className={styles.infoItem}>
                        <p>{t('Business.Users')} :</p>
                        <p>{data.visitors_count!}</p>
                    </div>
                    {/* <div className={styles.infoItem}>
                        <p>{t('Business.Mark')} :</p>
                        <p>0</p>
                    </div> */}
                </div>
                <img src={BUSINESS_TYPE_ICONS[data.type]} alt={`${data.type}.png`} className={styles.typeIcon} />
            </div>
            <img
                aria-describedby={id}
                src={MoreDots}
                alt="more.png"
                className={styles.actionButton}
                onClick={(e) => handleMoreIconClick(e)}
            />
            <Popper
                id={id}
                open={openPopper}
                anchorEl={anchor}
                placement="right-end"
                onMouseEnter={handlePopperMouseEnter}
                onMouseLeave={handlePopperMouseLeave}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.popUpBox}>
                    <div className={styles.popUpItem} onClick={(e) => {
                        e.stopPropagation();
                        onOpen()
                    }}>
                        <img src={Trash} alt="settings.png" className={styles.trashIcon} />
                        <p>{t('Buttons.Delete')}</p>
                    </div>
                </div>
            </Popper>
            <CustomDialog
                open={open}
                onClose={onClose}
                children={<DeleteCompanyDialog onClose={onClose} businessName={data.name} businessId={data.id} />}
            />
        </div>
    );
};

export default BusinesDashboardCard;
